<template>
  <div>
    <h1>{{ $t('message') }}</h1>
  </div>
</template>

<script>
export default {
  name: "JoinOrganization",
  data() {
    return {
      dynamicMenuItems: []
    };
  },
  mounted() {
    this.$emit("titlePage", "joinOrganization.title");
    this.$emit("dynamicMenuItems", this.dynamicMenuItems);
  }
};
</script>
